import GoHighLevelCRUDActions from '../actions/GoHighLevelCRUDActions';
import { GoHighLevelOauthToken } from '../model/ConnectionModel';
import {
  GoHighLevelLocation,
  GoHighLevelModel,
} from '../model/GoHighLevelModel';
import { setBusy, setUnBusy } from './common/commonReducers';

type AccountsAction = {
  type: string;
  accounts: GoHighLevelOauthToken[];
};

type LocationsAction = {
  type: string;
  locations: GoHighLevelLocation[];
};

type RevokeAction = {
  type: string;
  id: number | null;
};

const initialState: GoHighLevelModel = {
  busy: false,
  accounts: [],
  locations: [],
};

export const goHighLevel = (
  state = initialState,
  action: AccountsAction | LocationsAction | RevokeAction,
) => {
  switch (action.type) {
    case GoHighLevelCRUDActions.busyAction:
      return setBusy(state);
    case GoHighLevelCRUDActions.retrieveOauthUrlAction: {
      return {
        ...state,
        busy: false,
      };
    }
    case GoHighLevelCRUDActions.retrieveAccounts: {
      return {
        ...state,
        accounts: (action as AccountsAction).accounts,
        busy: false,
      };
    }

    case GoHighLevelCRUDActions.revokeAction: {
      const revokeAction = action as RevokeAction;
      if (revokeAction.id === null) {
        return {
          ...state,
          busy: false,
        };
      }
      return {
        ...state,
        busy: false,
        accounts: state.accounts.filter(acc => acc.id !== revokeAction.id),
      };
    }
    case GoHighLevelCRUDActions.resetStore: {
      return initialState;
    }
    case GoHighLevelCRUDActions.retrieveLocations: {
      return {
        ...state,
        locations: (action as LocationsAction).locations,
        busy: false,
      };
    }
    case GoHighLevelCRUDActions.unbusyAction:
      return setUnBusy(state);
    default:
      return state;
  }
};
